<template>
  <main class="flex justify-center w-full">
    <div class="w-full xl:w-5/6 max-xl:px-3 py-10 text-coal">
      <div v-if="company && !isLoading" class="min-h-[60vh]">
        <div class="flex items-start gap-10">
          <section class="w-2/3">
            <h1
              class="py-1 pl-3 border-l-4 border-black text-4xl text-black font-bold mb-3"
            >
              {{ company?.company_name }}
            </h1>

            <div
              v-if="company?.all_categories?.length > 0"
              class="mb-8 flex flex-wrap gap-2"
            >
              <router-link
                v-for="category in company.all_categories"
                :key="category.code"
                :to="`/yp/category/${category.code}`"
                class="bg-gray-300 text-coal text-sm py-1 px-3 rounded-xl hover:bg-gray-400"
              >
                {{ category.name }}
              </router-link>
            </div>

            <div
              v-if="company?.emails?.length > 0"
              class="flex items-center mb-2"
            >
              <font-awesome-icon icon="fa-solid fa-envelope" class="mr-2" />
              <a
                v-for="(email, mailIndex) in company.emails"
                :key="mailIndex"
                :href="`mail:${email}`"
                target="_blank"
                class="mr-1"
                >{{ email }}</a
              >
            </div>
            <div
              v-if="company?.phones?.length > 0"
              class="flex items-center mb-2"
            >
              <font-awesome-icon icon="fa-solid fa-phone" class="mr-2" />
              <a
                v-for="(phone, phoneIndex) in company.phones"
                :key="phoneIndex"
                :href="`tel:${phone}`"
                target="_blank"
                class="mr-1"
                >{{ phone }}</a
              >
            </div>
            <div
              v-if="company?.faxes?.length > 0"
              class="flex items-center mb-2"
            >
              <font-awesome-icon icon="fa-solid fa-fax" class="mr-2" />
              <a
                v-for="(fax, faxIndex) in company.faxes"
                :key="faxIndex"
                :href="`tel:${fax}`"
                target="_blank"
                class="mr-1"
                >{{ fax }}</a
              >
            </div>
            <div
              v-if="company?.websites?.length > 0"
              class="flex items-center mb-2"
            >
              <font-awesome-icon icon="fa-solid fa-globe" class="mr-2" />
              <p
                v-for="(website, webIndex) in company.websites"
                :key="webIndex"
                class="mr-1"
              >
                {{ website }}
              </p>
            </div>
            <div v-if="company.address" class="flex">
              <font-awesome-icon icon="fa-solid fa-map-pin" class="mr-2 pt-1" />
              <p>{{ company.address }}</p>
            </div>
          </section>

          <section class="flex justify-center w-1/3">
            <img
              v-if="company?.logo"
              :src="company.logo"
              alt="logo"
              class="w-1/2"
            />
            <p v-else class="text-gray-300 text-5xl font-bold mt-10">ЛОГО</p>
          </section>
        </div>

        <section
          v-if="company?.about_company"
          class="text-justify text-coal mt-10"
        >
          {{ company.about_company }}
        </section>
      </div>

      <div
        v-else-if="!company && !isLoading"
        class="flex flex-col justify-center items-center h-[60vh] w-full text-gray-500"
      >
        <img
          src="../../../assets/svg/no-data.svg"
          alt="not-found"
          class="w-1/3"
        />
        <p class="mt-4 text-lg font-medium">
          {{ lang === "mn" ? "Мэдээлэл байхгүй байна." : "No results found." }}
        </p>
      </div>

      <div
        v-else-if="isLoading"
        class="flex justify-center items-center w-full h-[60vh]"
      >
        <YPLoading />
      </div>
    </div>
  </main>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import YPLoading from "@/components/YellowPage/YPLoading.vue";

export default {
  name: "YPCompanyDetail",
  components: {
    YPLoading,
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const isRoute = ref(route.path);
    const lang = computed(() => store.getters.getLanguage);

    const isLoading = ref(false);
    const company = ref([]);

    const fetchCompany = async () => {
      isLoading.value = true;
      try {
        const response = await store.dispatch("yellow/fetchCompany", {
          lang: lang.value,
          id: route.params.id,
        });
        if (response?.data?.company) {
          company.value = response.data.company;
        } else {
          console.warn("No company in response", response);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      } finally {
        isLoading.value = false;
      }
    };

    const checkCompany = () => {
      const existingCompany = store.getters["yellow/getCompany"];
      if (!existingCompany || existingCompany.length === 0) {
        fetchCompany();
      } else {
        company.value = existingCompany;
      }
    };

    onMounted(() => {
      fetchCompany();
    });

    watch(
      () => route.params.id,
      () => {
        checkCompany();
      }
    );

    return { isRoute, lang, isLoading, company };
  },
};
</script>
